import { hasAuth } from "@/router/utils";
import { Directive } from "vue";

export const auth: Directive = {
  mounted(el: HTMLElement) {
    !hasAuth() && el.parentNode.removeChild(el);
  }
};
